<p></p>
<div id="student-outcome-header">
  <app-data-table
    [columns]="columns"
    [data]="rows"
    [pageSize]="5">
    <ng-template appColumnCell="comments" let-element>
      {{element.comments | slice:0:25}}
    </ng-template>
    <ng-template appColumnCell="action" let-element>
      <div class="div-padding-right-10">
        <button (click)="updateRowData(element)" class="btn btn-primary">{{enableViewEditButtons(element)}}</button>
      </div>
      @if (!element.submitted && hasDeletePermission) {
        <div>
          <button (click)="deleteRowData(element)" class="btn btn-primary">Delete</button>
        </div>
      }
      @if (element.approved && hasUnlockPermission) {
        <div>
          <button (click)="unlockProgressReport(element)" class="btn btn-primary">Unlock</button>
        </div>
      }
    </ng-template>
  </app-data-table>
  <div>
    @if (!showPanel && hasAddPermission) {
      <button (click)="addRowData({})" class="btn btn-primary">Add Progress Report</button>
    }
  </div>
</div>
@if (showPanel) {
  <student-outcome-detail
    (page)="pageEvent = $event"
    (onDataSaved) ="onDataSavedGet($event)"
    (onClosed)="onClosed($event)"
    [studentIdForLinkAssessment]="sessionStudentId"
    >
  </student-outcome-detail>
}
